import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

export async function recordFodycoinsEarn(uid, amount, description, data = {}, backingValue, originalCoinValue, saleAmount) {
  const recordBlock = httpsCallable(functions, 'recordFodycoinsBlock');
  const { data: result } = await recordBlock({
    type: 'earn',
    amount,
    description,
    data,
    backingValue: backingValue || null,
    originalCoinValue: originalCoinValue || null,
    saleAmount: saleAmount || null,
  });
  return result;
}

export async function recordFodycoinsSpend(uid, requestedDiscount, description, data = {}, originalCoinValue, saleAmount) {
  const recordBlock = httpsCallable(functions, 'recordFodycoinsBlock');
  const { data: result } = await recordBlock({
    type: 'spend',
    requestedDiscount,
    description,
    data,
    originalCoinValue: originalCoinValue || null,
    saleAmount: saleAmount || null,
  });
  return result;
}

export async function verifyFodycoinsChain(uid) {
  const verify = httpsCallable(functions, 'verifyFodycoinsChain');
  const { data: result } = await verify({});
  return result;
}
